import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { query } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-invoice-design-list',
  templateUrl: './invoice-design-list.component.html',
  styleUrls: ['./invoice-design-list.component.css']
})
export class InvoiceDesignListComponent implements OnInit {

  public menu_item_id = '69';
  public add_auth;
  public edit_auth;
  public del_auth;
  private dp = [];

  displayedColumns = ['invoice_design_name', 'invoice_design_name_en', 'page_format',
    'activity', 'preview', 'activate', 'copy', 'edit', 'del'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'table_name': 'invoice_design' };

  Success_Msg; Error_Msg; Del_Msg; Active; Inactive;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Active').subscribe((res: string) => {
      this.Active = res;
    });

    translate.get('Inactive').subscribe((res: string) => {
      this.Inactive = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    this.getDesignList();
  }

  ///////////////////////// Design List /////////////////////////
  getDesignList() {

    let query = "SELECT * FROM `invoice_design` WHERE `status` = '1'";
    // console.log(query);
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dp.forEach(element => {
          if (element.is_active == '1')
            element.activity = this.Active;
          else if (element.is_active == '0')
            element.activity = this.Inactive;
        });
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  ///////////////////////// Preview Design /////////////////////////
  preview(row) {
    window.open(this.applicationConstants.generateInvoice + "?id=" + row.invoice_design_id, "_blank");
  }

  activate(row) {
    let values = [{ 'table_name': this.model['table_name'], 'is_active': '1' }];
    let where = [{ 'invoice_design_id': row.invoice_design_id }];

    this.dp.forEach(element => {
      if (element.invoice_design_id != row.invoice_design_id) {
        values.push({ 'table_name': this.model['table_name'], 'is_active': '0' });
        where.push({ 'invoice_design_id': element.invoice_design_id })
      }
    });

    let obj = { cmd: 'update', values: values, where: where };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        //console.log(data);
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.getDesignList();
        }
        else 
          alert(this.Error_Msg);
      });
  }

  ///////////////////////// Delete Design /////////////////////////

  delDesign(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'invoice_design_id': row.invoice_design_id }];
      values.push({ 'table_name': 'invoice_design_field', 'invoice_design_id': row.invoice_design_id });
      values.push({ 'table_name': 'invoice_design_table', 'invoice_design_id': row.invoice_design_id });
      values.push({ 'table_name': 'invoice_design_total', 'invoice_design_id': row.invoice_design_id });
      values.push({ 'table_name': 'invoice_design_total_content', 'invoice_design_id': row.invoice_design_id });

      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.getDesignList();
          }
          else 
            alert(this.Error_Msg);
        });
    }
  }

}
